import { useMemo } from "react";

import { GqlMapShapeIcon } from "~/__generated__";

import { ProjectDeliverablesMap_FeatureFragment } from "../../../fragments.generated";

type MapLegendData = {
    species: { id: string; name: string; mapColor: string }[];
    pointFunctionTypes: { id: string; name: string; mapIcon: GqlMapShapeIcon }[];
    lineFunctionTypes: { id: string; name: string }[];
    polygonFunctionTypes: { id: string; name: string }[];
};

export function useMapLegendData(features: ProjectDeliverablesMap_FeatureFragment[]) {
    return useMemo(() => {
        return features.reduce<MapLegendData>(
            (acc, feature) => {
                if (feature.data.__typename !== "GqlEcologicalFunction") {
                    return acc;
                }

                const { speciesList, type } = feature.data;

                for (const species of speciesList) {
                    if (!acc.species.some(existingSpecies => existingSpecies.id === species.id)) {
                        acc.species.push(species);
                    }
                }

                const geometry = feature.geometry as GeoJSON.Geometry;

                if (geometry.type === "Point" || geometry.type === "MultiPoint") {
                    if (!acc.pointFunctionTypes.some(functionType => functionType.id === type.id)) {
                        acc.pointFunctionTypes.push(type);
                    }
                } else if (geometry.type === "LineString" || geometry.type === "MultiLineString") {
                    if (!acc.lineFunctionTypes.some(functionType => functionType.id === type.id)) {
                        acc.lineFunctionTypes.push(type);
                    }
                } else if (geometry.type === "Polygon" || geometry.type === "MultiPolygon") {
                    if (!acc.polygonFunctionTypes.some(functionType => functionType.id === type.id)) {
                        acc.polygonFunctionTypes.push(type);
                    }
                }

                return acc;
            },
            { species: [], pointFunctionTypes: [], lineFunctionTypes: [], polygonFunctionTypes: [] },
        );
    }, [features]);
}
